import { project2BaseUrl } from "./remoteClient";

export async function requestPrograms(token) {
    return await project2BaseUrl.get('programs/getPrograms', {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function createProgram(token, program) {
    return await project2BaseUrl.post('programs/createProgram', program, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function updateProgram(token, program) {

    return await project2BaseUrl.post('programs/updateProgram', program, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function deleteProgram(token, programId) {
    return await project2BaseUrl.post('programs/deleteProgram', programId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function saveProgramCourses(token, programId, programCourses) {
    return await project2BaseUrl.post('programs/saveProgramCourses?programId=' + programId, programCourses, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}

export async function getProgramCourses(token, programId) {
    return await project2BaseUrl.get('programs/getProgramCourses?programId=' + programId, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
}